import { makeStyles } from "@material-ui/core/styles";

const useCouponPreviewStyles = makeStyles(
  {
    accessBlockText: {
      textAlign: "center"
    },
    accessImg: {
      borderRadius: "25px",
      height: "180px",
      padding: "15px",
      width: "180px"
    },
    accessPaper: {
      alignItems: "center",
      backgroundColor: "#FFFFFF",
      borderRadius: "15px",
      display: "flex",
      flexDirection: "column",
      height: "max-content",
      overflowX: "hidden",
      padding: "0 20px 0 20px",
      width: "27rem"
    },
    barcodeImage: {
      alignSelf: "center",
      width: "70%"
    },
    barcodeSection: {
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      margin: "0 50px 1rem 50px",
      width: "32rem"
    },
    battery: {
      transform: "rotate(90deg)"
    },
    blockTxt: {
      paddingBottom: "20px",
      paddingRight: "20px",
      textAlign: "center",
      wordWrap: "break-word"
    },
    blockTxtMall: {
      paddingBottom: "20px",
      paddingRight: "20px",
      wordWrap: "break-word"
    },
    boldTxt: {
      color: "#002972",
      fontSize: "1.125rem",
      fontWeight: "bold",
      paddingBottom: "15px",
      paddingTop: "15px"
    },
    boldTxtTitle: {
      color: "#002972",
      fontSize: "0.875rem",
      fontWeight: "bold",
      paddingBottom: "15px",
      paddingTop: "15px"
    },
    cardContent: {
      backgroundColor: "#F4F8FF"
    },
    cellphoneIcons: {
      "& .MuiSvgIcon-root": {
        fill: "#FFFFFF"
      }
    },
    circle: {
      backgroundColor: "#F4F8FF",
      borderRadius: "50%",
      height: "50px",
      width: "80px"
    },
    dialogContent: {
      maxHeight: "53rem",
      maxWidth: "34rem",
      overflowX: "hidden",
      padding: 0
    },
    editorBlockContainer: {
      padding: "0 18px 0 30px"
    },
    hr: {
      backgroundColor: "#F4F8FF",
      height: "3px",
      marginBottom: "15px",
      marginTop: "15px"
    },
    imageAccesories: {
      display: "flex",
      justifyContent: "space-between",
      padding: "10px",
      width: "100%"
    },
    imageContainer: {
      alignContent: "space-between",
      display: "flex",
      flexWrap: "wrap",
      height: "100%",
      width: "100%"
    },
    imageInfo: {
      "& .MuiSvgIcon-root": {
        paddingRight: "5px"
      },
      backgroundColor: "#E8EAEE",
      borderRadius: "3px",
      display: "flex",
      padding: "5px"
    },
    mainPromoImg: {
      backgroundPosition: "center",
      backgroundSize: "100% 100%",
      borderRadius: "5px",
      height: "480px",
      minWidth: "320px",
      opacity: 0.8,
      width: "480px",
      zIndex: 10
    },
    paper: {
      backgroundColor: "white",
      borderRadius: "20px",
      display: "flex",
      height: "40px",
      position: "relative",
      top: "15px",
      width: "100%"
    },
    previewModal: {
      "& .MuiDialog-paperWidthSm": {
        maxWidth: "min-content"
      }
    },
    selectedCouponTabItem: {
      color: "#0030FF"
    },
    subtitle: {
      paddingTop: "15px"
    },
    tabContainer: {
      "& > div > .MuiTabs-flexContainer": {
        justifyContent: "space-evenly"
      }
    },
    tabContent: {
      display: "none"
    },
    tabContentActive: {
      display: "block"
    },
    tabRoot: {
      fontSize: "16px",
      textTransform: "none",
      width: "50%"
    },
    tabsRoot: {
      "& .MuiTabs-flexContainer": {
        borderBottom: "2px solid #CED3DD"
      },
      "& .MuiTabs-indicator": {
        backgroundColor: "#0030FF"
      },
      fontSize: "16px",
      marginBottom: 12,
      textTransform: "none"
    },
    textAlign: {
      textAlign: "center"
    },
    textContainer: {
      "& .MuiTypography-root": {
        paddingLeft: "30px"
      },
      backgroundColor: "#FFFFFF",
      position: "relative",
      zIndex: 10
    },
    ticketLayer: {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "1rem",
      width: "32rem"
    },
    ticketLine: {
      marginLeft: "25px",
      marginRight: "25px",
      width: "80%"
    },
    titleBar: {
      display: "flex",
      justifyContent: "space-between",
      width: "100%"
    },
    validUntilTxt: {
      color: "#747C8C"
    },
    voucherViewDetails: {
      color: "#0030FF",
      fontSize: "0.875rem",
      fontWeight: "bold"
    }
  },
  { name: "CouponPreview" }
);

export default useCouponPreviewStyles;
